import React, { useState } from 'react';
import { auth } from '../firebase';
import { signInWithEmailAndPassword } from 'firebase/auth';

function LoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await signInWithEmailAndPassword(auth, email, password);
    } catch (error) {
      alert("Giriş Başarısız: E-posta veya şifre hatalı!");
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-green-50 font-sans">
      <div className="bg-white p-8 rounded-[2.5rem] shadow-2xl w-full max-w-sm border-b-8 border-green-600">
        
        {/* LOGO VE BAŞLIK */}
        <div className="text-center mb-8">
          <div className="bg-green-100 w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-4">
            <span className="text-3xl">🚚</span>
          </div>
          <h1 className="text-2xl font-black text-green-800 uppercase tracking-wider">Devay Panel</h1>
          <p className="text-slate-500 text-sm font-medium">Personel Giriş Sistemi</p>
        </div>

        {/* FORM ALANI */}
        <form onSubmit={handleLogin} className="space-y-4">
          <div className="relative">
            <input 
              type="email" 
              placeholder="E-posta" 
              className="w-full p-4 bg-slate-100 rounded-2xl outline-none focus:ring-2 focus:ring-green-500 transition-all text-slate-800 placeholder:text-slate-400 font-medium"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <div className="relative">
            <input 
              type="password" 
              placeholder="Şifre" 
              className="w-full p-4 bg-slate-100 rounded-2xl outline-none focus:ring-2 focus:ring-green-500 transition-all text-slate-800 placeholder:text-slate-400 font-medium"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          <button 
            type="submit"
            disabled={loading}
            className={`w-full bg-green-600 text-white p-4 rounded-2xl font-black shadow-lg shadow-green-200 transition-all active:scale-95 
              ${loading ? 'opacity-50 cursor-not-allowed' : 'hover:bg-green-700'}`}
          >
            {loading ? 'GİRİŞ YAPILIYOR...' : 'GİRİŞ YAP'}
          </button>
        </form>

        {/* ALT BİLGİ */}
        <div className="mt-8 text-center text-[10px] text-slate-400 font-bold uppercase tracking-widest">
          © 2026 Devay Lojistik
        </div>
      </div>
    </div>
  );
}

export default LoginPage;